// Toggle interactivity - use jQuery SlideToggle if needed
(function($){
	$(".wp-block-baytek-toggle .toggle-header").on( "click", function() {
		$(this).next().slideToggle("300", function() {
			$(this).parent().toggleClass("expanded");
		});
	});

	/**
	 * Open positions
	 */
	$(document).on('click', '.wp-block-group.open-position .toggle-trigger.closed', function() {
		//Wipe left
		$(this).addClass('swapping');

		//Change labels/arrow
		window.setTimeout(() => {
			$(this).removeClass('closed');
			$(this).parents('.wp-block-group.open-position').addClass("open");

			//Wipe right
			$(this).removeClass('swapping');
		}, 400);

		//Slide body down
		$(this).next('.toggle-body').slideDown(400, function(e) {
			$(this).removeClass('closed');
			$(this).parents('.wp-block-group.open-position').addClass("open");
		});

	});

	$(document).on('click', '.wp-block-group.open-position .toggle-trigger:not(.closed)', function() {
		//Wipe left
		$(this).addClass('swapping');

		//Change labels/arrow
		window.setTimeout(() => {
			$(this).addClass('closed');
			$(this).parents('.wp-block-group.open-position').removeClass("open");



			//Wipe right
			$(this).removeClass('swapping');
		}, 400);

		//Slide body up
		$(this).next('.toggle-body').slideUp(400, function(e) {
			$(this).addClass('closed');
			$(this).parents('.wp-block-group.open-position').removeClass("open");
		});
	});

	var hash = window.location.hash;
	if (hash) {
	  hash = hash.substring(1);
	  console.log(hash);
	} else {}

	if(document.location.hash.search(hash)){
	    $('#' + hash + '.open-position .toggle-trigger.closed').trigger('click');
	}else {}


})(jQuery);
